export default __webpack_public_path__ + "static/media/simflexity-logo.980c9ba2.svg";